"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _widgets = require("@quarkly/widgets");
var _components = require("@quarkly/components");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _atomize = _interopRequireDefault(require("@quarkly/atomize"));
var _resizeObserver = _interopRequireDefault(require("@react-hook/resize-observer"));
var _props = require("./props");
var _utils = require("../utils");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var MarqueeContainer = (0, _atomize["default"])(_styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n    ", "\n"])), function (_ref) {
  var pauseOnHover = _ref.pauseOnHover;
  return pauseOnHover && "&:hover div {\n            animation-play-state: paused !important;\n        }\n    ";
}, function (_ref2) {
  var pauseOnClick = _ref2.pauseOnClick;
  return pauseOnClick && "&:active div {\n            animation-play-state: paused !important;\n        }\n    ";
}))();
var MarqueeAnimation = (0, _atomize["default"])(_styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    @keyframes scroll {\n        0% {\n            transform: translateX(0%);\n        }\n        100% {\n            transform: translateX(-100%);\n        }\n    }\n"]))))();
var Marquee = function Marquee(_ref3) {
  var delay = _ref3.delay,
    speedFromProps = _ref3.speed,
    direction = _ref3.direction,
    pauseOnHover = _ref3.pauseOnHover,
    pauseOnClick = _ref3.pauseOnClick,
    props = _objectWithoutProperties(_ref3, ["delay", "speed", "direction", "pauseOnHover", "pauseOnClick"]);
  var containerRef = (0, _react.useRef)();
  var marqueeRef = (0, _react.useRef)(null);
  var mode = (0, _widgets.useConstructorMode)();
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    duration = _useState2[0],
    setDuration = _useState2[1];
  var _useState3 = (0, _react.useState)(1),
    _useState4 = _slicedToArray(_useState3, 2),
    count = _useState4[0],
    setCount = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isResized = _useState6[0],
    setIsResized = _useState6[1];
  var calculateWidthCounter = (0, _react.useRef)(0);
  var _useOverrides = (0, _components.useOverrides)(props, _props.overrides),
    override = _useOverrides.override,
    children = _useOverrides.children,
    rest = _useOverrides.rest;
  var speed = (0, _react.useMemo)(function () {
    return (0, _utils.getNumber)(speedFromProps, _props.defaultProps.speed, function (val) {
      return val >= 0;
    });
  }, [speedFromProps]);
  var calculateWidth = (0, _react.useCallback)(function () {
    if (!marqueeRef.current || !containerRef.current) {
      return;
    }
    var containerWidth = containerRef.current.getBoundingClientRect().width;
    var marqueeWidth = marqueeRef.current.getBoundingClientRect().width;
    if (marqueeWidth === 0) return;
    setDuration(marqueeWidth / speed);
    setCount(Math.ceil(containerWidth / marqueeWidth));
    if (calculateWidthCounter.current < 2) {
      calculateWidthCounter.current += 1;
    } else {
      setIsResized(true);
    }
  }, [speed]);
  (0, _react.useLayoutEffect)(function () {
    if (mode === 'constructor') {
      setIsResized(false);
      calculateWidthCounter.current = 0;
    }
    calculateWidth();
  }, [calculateWidth, mode, speed]);
  var handleResize = (0, _utils.useDebouncedCallback)(function () {
    if (mode === 'constructor') return;
    calculateWidth();
  }, 200);
  (0, _resizeObserver["default"])(containerRef, handleResize);
  var isEmpty = (0, _utils.isEmptyChildren)(children);
  var marqueeProps = (0, _react.useMemo)(function () {
    var animationDuration = "".concat(duration, "s");
    var animationDirection = direction === 'left' ? 'normal' : 'reverse';
    var animationPlaystate = mode !== 'constructor' ? 'running' : 'paused';
    var animationDelay = !isResized ? delay : '0s';
    var animation = !isEmpty && mode !== 'constructor' ? "".concat(animationDuration, " linear ").concat(animationDelay, " infinite ").concat(animationDirection, " ").concat(animationPlaystate, " scroll") : '';
    return {
      style: _objectSpread({
        animation: animation
      }, isEmpty && {
        flex: 1
      })
    };
  }, [duration, direction, mode, isResized, delay, isEmpty]);
  return /*#__PURE__*/_react["default"].createElement(MarqueeContainer, _extends({
    ref: containerRef,
    display: "flex",
    "flex-direction": "row",
    width: "100%",
    "overflow-x": mode !== 'constructor' ? 'hidden' : 'unset',
    pauseOnHover: pauseOnHover,
    pauseOnClick: pauseOnClick
  }, rest), /*#__PURE__*/_react["default"].createElement(MarqueeAnimation, _extends({
    key: "".concat(-1, "_").concat(count),
    ref: marqueeRef
  }, override('Container'), marqueeProps), children, (0, _utils.isEmptyChildren)(children) && /*#__PURE__*/_react["default"].createElement(_widgets.Placeholder, {
    message: "Drop content here",
    width: "100%"
  })), !isEmpty && _toConsumableArray(Array(count).keys()).map(function (x) {
    return /*#__PURE__*/_react["default"].createElement(MarqueeAnimation, _extends({
      key: "".concat(x, "_").concat(count)
    }, marqueeProps, override('Container'), {
      "data-qoverride": undefined,
      "data-key": "".concat(x, "_").concat(count)
    }), mode !== 'constructor' && children);
  }));
};
Object.assign(Marquee, {
  description: {
    ru: 'Компонент для создания на странице бегущей строки.'
  },
  propInfo: _props.propInfo,
  defaultProps: _props.defaultProps,
  overrides: _props.overrides
});
var _default = Marquee;
exports["default"] = _default;